import {useQuery} from '@tanstack/react-query';
import {API, GuestTokenStorageHandler} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useSummary} from 'context/summary';

type Props = {
  enabled?: boolean;
};
function useFetchUser({enabled}: Props = {enabled: true}) {
  const {isInstantCheckInEnabled} = useSummary();
  const guestToken = GuestTokenStorageHandler.getToken();

  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.user, guestToken],
    queryFn: () => API.auth.getMe(),
    enabled: Boolean(enabled && isInstantCheckInEnabled && guestToken),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export {useFetchUser};
